import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-meetings',
  templateUrl: './meetings.component.html',
  styleUrl: './meetings.component.css',
})

export class MeetingsComponent implements OnInit {
  ngOnInit(): void {
    // Meetings content is rendered without blocking on remote data.
  }

  onActivate(elementRef: any) {
  }
}
